// Error contains error code and error messages
export const errorList = new Map([
    [ '1',
    'We don\'t recognize your User ID or Password. ' +
    'Please verify your information and try again. ' +
    'Your account will be locked after five failed login attempts.' ],
    [ '2', 'Your new password cannot be the same as your current password. Please re-enter your information below.' ],
    [ '3', 'The confirmation password that you typed is incorrect. Please re-enter your information below.' ],
    [ '4', 'Password must contain a number, a letter and at least 8 characters' ],
    [ '5', 'We don\'t recognize your User ID or Password. Please verify your information and try again below. Your account will be locked after five failed login attempts.' 
    + '<br/><br/>If you do not have an Equitable account, please click <a href="#{ebclaims.url}#" class="btn-link">here</a> to register as an Employee/Group Benefits member and file a claim.' 
    + ' If you have any questions, please give our customer service team a call at 1-866-274-9887 for help.'
     + ' We\'re here to assist you.' ]
]);
